module.exports = [
    'ועדות מקצועיות',
    'פרוטוקולים',
    'ועד מנהל כללי',
    'מועצת קמפוסים',
    'תקציבים שנתיים',
    'ניהול תקין',
    'ועד מנהל קמפוסים',
    'ועדת כספים',
    'פורום מוביל'
];
